import React from 'react';
import { StatefulMenu, NestedMenus } from 'baseui/menu';
import { mergeOverrides } from 'baseui';
import { IDummyProps } from './types';

import { overrides } from './overrides';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { items = [], onItemSelect, styleListContainer, overrides: clientOverrides, hideFocusRing, ...rest } = props;

	return (
			<NestedMenus>
				<StatefulMenu
					items={items}
					onItemSelect={onItemSelect}
					// @ts-ignore
					overrides={mergeOverrides(overrides(props), clientOverrides)}
					rootRef={ref}
					{...rest}
				/>
			</NestedMenus>
	);
});
